import React, { useState, useEffect } from 'react';
import ElanCard from '../components/ElanCard';
import './AnaSehife.css';
import { BsChatDots } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import ElanController from '../api/elan/ElanController'; // ElanController'ı import et
import UserController from '../api/user/UserController';
import LotoreyaController from '../api/lotoreya/LotoreyaController';

const AnaSehife = () => {
  const [filteredElans, setFilteredElans] = useState([]); // Filterlənmiş elanlar
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(true); // Yüklənmə vəziyyəti
  // eslint-disable-next-line no-unused-vars
  const [premiumElans, setPremiumElans] = useState([]); // Premium elanlar
  // eslint-disable-next-line no-unused-vars
  const [normalElans, setNormalElans] = useState([]); // Normal elanlar
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/chat');
  };

  useEffect(() => {
    const checkUserStatus = async () => {
      const userId = localStorage.getItem('motoTaksiUserId');
      const currentPassword = localStorage.getItem('currentPassword');

      if (userId && currentPassword) {
        try {
          const user = await UserController.getUserById(userId); // ElanController əvəzinə UserController

          if (user.isDisable) {
            alert('Hesabınız administrator tərəfindən bloklanıb.');
            localStorage.clear();
            navigate('/auth');
            return;
          }

          if (user.password !== currentPassword) {
            alert('Şifrəniz dəyişdirilib və ya yanlışdır. Zəhmət olmasa yenidən daxil olun.');
            localStorage.clear();
            navigate('/auth');
            return;
          }

        } catch (error) {
          console.error('İstifadəçi yoxlanarkən xəta:', error);
          localStorage.clear();
          navigate('/auth');
        }
      }
    };

    checkUserStatus();

    const loadElans = async () => {
      try {
        const response = await ElanController.getAllElans();
        const allLotoreyas = await LotoreyaController.getAllLotoreyas(); // Lotoreyalar da çəkildi

        const premiumElans = response.filter(elan => elan.premium);
        const normalElans = response.filter(elan => !elan.premium);

        premiumElans.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        normalElans.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setPremiumElans(premiumElans);
        setNormalElans(normalElans);

        // Əlavə: Elanlara uyğun lotoreyaStatus veririk:
        const limitedElans = [];

        ['taxi', 'sales', 'rent', 'spare'].forEach(category => {
          const premium = premiumElans
            .filter(e => e.category === category)
            .map(e => {
              const lotoreya = allLotoreyas.find(l => l.elanId === e.id);
              return {
                ...e,
                lotoreyaStatus: lotoreya
                  ? (lotoreya.carx == null
                    ? (lotoreya.isAccept ? 'accepted' : 'pending')
                    : null)
                  : null

              };
            });

          const normal = normalElans
            .filter(e => e.category === category)
            .map(e => {
              const lotoreya = allLotoreyas.find(l => l.elanId === e.id);
              return {
                ...e,
                lotoreyaStatus: lotoreya
                  ? (lotoreya.carx == null
                    ? (lotoreya.isAccept ? 'accepted' : 'pending')
                    : null)
                  : null

              };
            });

          premium.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          normal.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

          let combined = [...premium];
          if (combined.length < 10) {
            const extra = normal.slice(0, 10 - combined.length);
            combined = [...combined, ...extra];
          }

          limitedElans.push(...combined);
        });

        setFilteredElans(limitedElans);

      } catch (error) {
        console.error('Elanlar və lotoreyalar yüklənərkən xəta:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadElans();
  }, [navigate]);

  // Kategoriyaya görə filterləmə funksiyası
  const handleCategoryClick = (category) => {
    navigate(`/elanlar/${category}`);  // Kategoriyanı göstərəcək səhifəyə yönləndiririk
  };

  // Elan kartına tıklananda bu metod işə düşəcək
  const handleElanClick = (id) => {
    navigate(`/elan/${id}`);  // Elanın id-sinə əsasən URL-dəki səhifəyə yönləndiririk
  };

  // Daha çox elanı yükləmək üçün
  const loadMore = (category) => {
    navigate(`/elanlar/${category}`);  // Kategoriyanın tam səhifəsini göstər
  };

  return (
    <div className="ana-container">
      {/* Kateqoriya */}
      <div className="category-container">
        <div className="category-card" onClick={() => handleCategoryClick('taxi')}>
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqNipI0BHsZ5uauyUnyIAP3Ecnev7QTXJV-Q&s" alt="Moto Taksi" />
          <span>Moto Taksi Elanları</span>
        </div>

        <div className="category-card" onClick={() => handleCategoryClick('sales')}>
          <img src="https://images.ctfassets.net/8zlbnewncp6f/4RxbRFRNzlhu2RJfqBgeF7/e472da1e62b85dd6c55fb5845eafe0a5/bajaj-pulsar-n250-primer-plano.jpg?w=600&fm=webp&q=90" alt="Alqı-Satqı" />
          <span>Moto Alqı-Satqı Elanları</span>
        </div>

        <div className="category-card" onClick={() => handleCategoryClick('rent')}>
          <img src="https://www.motorentmigjorn-lasavina.com/backoffice/uploadImages/621Medley-S-Blue.png" alt="Moto Kirayə" />
          <span>Moto Kirayə Elanları</span>
        </div>

        <div className="category-card" onClick={() => handleCategoryClick('spare')}>
          <img src="https://s.alicdn.com/@sc04/kf/H80485c4ee5fb4557a4d23e9f42dcc41bU.jpg_300x300.jpg" alt="Moto Zapçast" />
          <span>Moto Zapçast Elanları</span>
        </div>

        {/* Sifariş Et Düyməsi */}
        <button
          type="button"
          className="home-sifarish-btn mobile-only"
          onClick={() => navigate('/motosifarish')}
        >
          MotoTaksi Sifariş Et
        </button>

      </div>

      {/* Moto Taksi Elanları */}
      <h2 className="section-title">Moto Taksi Elanları</h2>
      <div className="elans-container">
        {filteredElans
          .filter(elan => elan.category === 'taxi')
          .map((elan, index) => (
            <ElanCard
              key={`taxi-${index}`}
              {...elan}
              title={
                elan.title.length > 25
                  ? elan.title.slice(0, 25) + '...'
                  : elan.title
              }
              description={
                elan.description.length > 30
                  ? elan.description.slice(0, 30) + '...'
                  : elan.description
              }
              onClick={() => handleElanClick(elan.id)}
            />

          ))}
      </div>
      <button className="load-more" onClick={() => loadMore('taxi')}>Daha çox</button>

      {/* Moto Alqı-Satqı Elanları */}
      <h2 className="section-title" style={{ marginTop: '50px' }}>Moto Alqı-Satqı Elanları</h2>
      <div className="elans-container">
        {filteredElans
          .filter(elan => elan.category === 'sales')
          .map((elan, index) => (
            <ElanCard
              key={`sales-${index}`}
              {...elan}
              title={
                elan.title.length > 25
                  ? elan.title.slice(0, 25) + '...'
                  : elan.title
              }
              description={
                elan.description.length > 30
                  ? elan.description.slice(0, 30) + '...'
                  : elan.description
              }
              onClick={() => handleElanClick(elan.id)}
              lotoreyaStatus={elan.lotoreyaStatus}
            />

          ))}
      </div>
      <button className="load-more" onClick={() => loadMore('sales')}>Daha çox</button>

      {/* Moto Kirayə Elanları */}
      <h2 className="section-title" style={{ marginTop: '50px' }}>Moto Kirayə Elanları</h2>
      <div className="elans-container">
        {filteredElans
          .filter(elan => elan.category === 'rent')
          .map((elan, index) => (
            <ElanCard
              key={`rent-${index}`}
              {...elan}
              title={
                elan.title.length > 25
                  ? elan.title.slice(0, 25) + '...'
                  : elan.title
              }
              description={
                elan.description.length > 30
                  ? elan.description.slice(0, 30) + '...'
                  : elan.description
              }
              onClick={() => handleElanClick(elan.id)}
            />

          ))}
      </div>
      <button className="load-more" onClick={() => loadMore('rent')}>Daha çox</button>

      {/* Moto Zapçast Elanları */}
      <h2 className="section-title" style={{ marginTop: '50px' }}>Moto Zapçast Elanları</h2>
      <div className="elans-container">
        {filteredElans
          .filter(elan => elan.category === 'spare')
          .map((elan, index) => (
            <ElanCard
              key={`spare-${index}`}
              {...elan}
              title={
                elan.title.length > 25
                  ? elan.title.slice(0, 25) + '...'
                  : elan.title
              }
              description={
                elan.description.length > 30
                  ? elan.description.slice(0, 30) + '...'
                  : elan.description
              }
              onClick={() => handleElanClick(elan.id)}
              lotoreyaStatus={elan.lotoreyaStatus}
            />

          ))}
      </div>
      <button className="load-more" style={{ marginBottom: '100px' }} onClick={() => loadMore('spare')}>Daha çox</button>

      {/* Chat Button */}
      <div className="whatsapp-float" onClick={handleClick}>
        <button className="whatsapp-button">
          <BsChatDots />
        </button>
      </div>
    </div>
  );
};

export default AnaSehife;

